import { useEffect, useId, useState } from 'react'

import { getMermaidDiagramId, renderMermaid } from '../utils/mermaid'

export function useMermaid(code) {
  const reactId = useId()
  const diagramId = getMermaidDiagramId(reactId)

  const [render, setRender] = useState(null)

  useEffect(() => {
    let isCurrent = true

    renderMermaid({ code, id: diagramId }).then(
      svg => {
        if (isCurrent) {
          setRender({ svg })
        }
      },
      () => {
        if (isCurrent) {
          setRender({ hasFailed: true })
        }
      }
    )

    return () => {
      isCurrent = false
    }
  }, [code, diagramId])

  return { hasFailed: Boolean(render?.hasFailed), svg: render?.svg }
}
